import type { SVGProps } from 'react';

const SocialTag = (props: SVGProps<SVGSVGElement>) => (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g filter="url(#filter0_i_3721_9867)">
            <path
                d="M3.81006 0C5.19077 0 6.31006 1.11929 6.31006 2.5C6.31006 3.39212 5.84232 4.17476 5.13916 4.61719C5.78478 4.86205 6.34367 5.28195 6.76221 5.81641C7.08563 5.31761 7.5617 4.92672 8.12549 4.71289C7.59814 4.38106 7.24756 3.79407 7.24756 3.125C7.24756 2.08947 8.08702 1.25 9.12256 1.25C10.1581 1.25 10.9976 2.08947 10.9976 3.125C10.9976 3.79407 10.647 4.38106 10.1196 4.71289C11.1807 5.11533 11.9351 6.14158 11.9351 7.34375V7.65039C11.935 8.25765 11.4427 8.74992 10.8354 8.75H7.54248C7.43778 9.45714 6.82951 10 6.09326 10H1.52686C0.717015 10 0.0600586 9.34304 0.0600586 8.5332V8.125C0.0600586 6.52211 1.06617 5.15377 2.48096 4.61719C1.7778 4.17476 1.31006 3.39212 1.31006 2.5C1.31006 1.11929 2.42935 0 3.81006 0Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_3721_9867"
                x="0.0600586"
                y="0"
                width="11.875"
                height="10.2"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.2" />
                <feGaussianBlur stdDeviation="0.1" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3721_9867" />
            </filter>
        </defs>
    </svg>
);

export default SocialTag;
